import UserInfo from '@/lib/user-info'
import i18n from '@/lib/i18n'
export default class Currency {
  static get JPY() {
    return 'jpy'
  }
  static get USD() {
    return 'usd'
  }

  static getCurrencyItems() {
    return [
      {
        name: i18n.tt('customBillingCurrencyJPY'),
        value: Currency.JPY,
      },
      {
        name: i18n.tt('customBillingCurrencyUSD'),
        value: Currency.USD,
      },
    ]
  }

  static getItemByCurrency(currency) {
    const items = this.getCurrencyItems()
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.value === currency) {
        return item
      }
    }
    return null
  }

  static getCurrencyIconClass() {
    const lang = UserInfo.getLanguage()
    if (lang === 'ja') {
      return 'fa fa-fw fa-jpy'
    }
    return 'fa fa-fw fa-usd'
  }
}
